export default __webpack_public_path__ + "static/prompt_graph_eng-1fcc657f1ef66e5a0192e3fe5ef6e146.png";